
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { ITheme, IThemeService } from '../models';

@Injectable({
	providedIn: 'root'
})
export class CSSThemeService implements IThemeService {

	private readonly style: HTMLLinkElement;

	public current$: Observable<string> = new Subject();

	constructor() {
		this.style = document.createElement('link');
		this.style.rel = 'stylesheet';
		document.head.appendChild(this.style);

		this.style.addEventListener('load', _ => document.body.classList.remove('theme-loading'))
	}

	install(..._themes: ITheme[]) {
        //
	}

	useTheme(value: string) {
		document.body.classList.add('theme-loading')

		localStorage.setItem('theme', value);
		this.style.href = `styles.theme-${value}.css`;
	}
}
